import ProductPage from '../[countryCode]/product/[paramName]'
import {withRedirectForNoCountryCode} from "../../components/with_redirect_for_no_country_code";

export { getSingleProductStaticProps as getStaticProps } from '../../lib/static_props'

export default withRedirectForNoCountryCode(ProductPage)

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  }
}